import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';

// project imports
import MinimalLayout from 'layout/MinimalLayout';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/Login')));
const AuthSignup = Loadable(lazy(() => import('views/pages/Signup')));

// ===========================|| AUTHENTICATION ROUTING ||=========================== //

const AuthenticationRoutes = ({ isLoggedIn, isPaid }) => ({
    path: '/',
    element: <MinimalLayout />,
    children: [
        {
            path: '/login',
            element: isLoggedIn ? <Navigate to={isPaid ? '/' : '/account'} replace /> : <AuthLogin />
        },
        {
            path: '/signup',
            element: isLoggedIn ? <Navigate to={isPaid ? '/' : '/account'} replace /> : <AuthSignup />
        }
    ]
});

export default AuthenticationRoutes;
